import React from 'react';
import PropTypes from 'prop-types';
import { Button, Tooltip } from 'antd';
import { LeftOutlined, SettingOutlined, CrownOutlined } from '@ant-design/icons';
import Text from 'antd/lib/typography/Text';
import { startCase } from 'lodash';
import AvatarS3 from '../../../../shared/images/AvatarS3';
import '../../styles/index.scss';

const TeamDetailsHeader = ({
  team,
  onBack,
  onSettingsClick,
  isMobile,
  isTablet,
}) => {
  return (
    <div className="project-header">
      {/* Back Button */}
      <div className="project-header__back">
        <Button
          className="project-header__back-btn"
          onClick={onBack}
          type="text"
        >
          <LeftOutlined />
          <Text strong>Back</Text>
        </Button>
      </div>

      {/* Header Row */}
      <div className={`project-header__row ${isMobile || isTablet ? 'project-header__row--stacked' : ''}`}>
        {/* Title Section */}
        <div className="project-header__title-section">
          <h1 className="project-header__title">
            {team?.name || 'Untitled Team'}
          </h1>
          {team?.description && (
            <div className="project-header__owner" style={{ marginTop: 2 }}>
              <span className="project-header__owner-name" style={{ color: '#64748b' }}>
                {team.description}
              </span>
            </div>
          )}
          {team?.leader && (
            <div className="project-header__owner" style={{ marginTop: 4 }}>
              <CrownOutlined style={{ color: '#faad14', marginRight: 4 }} />
              <Tooltip title="Team Leader">
                <AvatarS3
                  imgKey={team.leader.avatar?.key}
                  username={team.leader.name || team.leader.username}
                  avatarProps={{ size: 20 }}
                />
              </Tooltip>
              <span className="project-header__owner-name" style={{ marginLeft: 4 }}>
                {startCase(team.leader.name || team.leader.username)}
              </span>
            </div>
          )}
        </div>

        {/* Actions */}
        <div className={`project-header__actions ${isMobile || isTablet ? 'project-header__actions--full' : ''}`}>
          <Button
            className="project-header__settings-btn"
            onClick={onSettingsClick}
            icon={<SettingOutlined />}
          >
            Settings
          </Button>
        </div>
      </div>
    </div>
  );
};

TeamDetailsHeader.propTypes = {
  team: PropTypes.object,
  onBack: PropTypes.func.isRequired,
  onSettingsClick: PropTypes.func.isRequired,
  isMobile: PropTypes.bool,
  isTablet: PropTypes.bool,
};

TeamDetailsHeader.defaultProps = {
  team: null,
  isMobile: false,
  isTablet: false,
};

export default TeamDetailsHeader;
